const productSettings = {
  pageTitle: "Impostazioni Lappa",
  backToSettings: "Impostazioni",
  pageHelmetTitle: "Cronologia fatturazione",
  pageTitles: {
    applications: "Applicazioni",
    billings: "Fatturazione",
    plansAndUsage: "Piani e consumo",
    payments: "Pagamenti",
    sandbox: "Sandbox",
  },
  customerBillingNote:
    "Qui sono mostrati solo i dati di fatturazione della tua azienda (non i documenti dei clienti).",
  mainTabs: {
    applications: "Applicazioni",
    billingHistory: "Cronologia fatturazione",
    plansAndUsage: "Piani e consumo",
    payments: "Pagamenti",
    sandbox: "Sandbox",
  },
  sandbox: {
    cancel: "Annulla",
    navigation: {
      switchTo: "Passa alla sandbox",
      currentSandbox: "Sandbox attiva",
      switchBack: "Torna all'azienda live",
      active: "Sandbox attiva",
      open: "Passa a questa sandbox",
      empty: "Non è stata ancora creata alcuna sandbox.",
      create: "Crea sandbox",
      manage: "Gestisci sandbox",
      singleLimit: "È possibile creare una sola sandbox per azienda.",
    },
    access: {
      title: "Questa funzionalità non è disponibile nella Sandbox",
      disabledDescription:
        "Torna alla tua azienda attiva per accedere a questa funzionalità.",
      noPermission:
        "Non hai l'autorizzazione per utilizzare questa funzionalità nella Sandbox.",
      disabledHint: "Non disponibile nella Sandbox",
    },
    create: {
      configurationTitle: "Configurazione iniziale",
      configurationDescription: "Scegli cosa includere nella nuova sandbox.",
      copyAccount: "Copia account",
      copyAccountDescription:
        "Impostazioni e funzionalità saranno copiate dall'account live.",
      newSandbox: "Crea nuova sandbox",
      newSandboxDescription: "Niente sarà copiato dall'account live.",
      next: "Avanti",
      nameTitle: "Assegna un nome alla sandbox",
      nameDescription:
        "Abbiamo generato un nome, ma puoi modificarlo ora o in seguito.",
      nameLabel: "Nome sandbox",
      nameRequired: "Inserisci un nome per la sandbox.",
      nameTooLong: "Il nome della sandbox deve contenere al massimo 80 caratteri.",
      regenerate: "Rigenera",
      back: "Indietro",
      submit: "Crea sandbox",
    },
    manage: {
      title: "Gestisci sandbox",
      description:
        "Crea un ambiente isolato per i test senza modificare i dati live.",
      emptyTitle: "Nessuna sandbox",
      emptyDescription: "Crea una sandbox per testare impostazioni e flussi.",
      sandboxDescription: "Isolata dai dati dell'azienda live",
      delete: "Elimina sandbox",
      deleteTitle: "Elimina sandbox",
      deleteDescription:
        "Questa sandbox e tutti i suoi dati saranno eliminati definitivamente. L'azione non può essere annullata.",
      deleteActiveHint:
        "Torna all'azienda live prima di eliminare questa sandbox.",
      created: "Sandbox creata correttamente.",
      deleted: "Sandbox eliminata correttamente.",
      retry: "Riprova",
    },
  },
  plansAndUsage: {
    innerTabs: {
      overview: "Panoramica",
      includedInPlan: "Incluso nel piano",
      usageAndLimits: "Consumo",
    },
    emptyProduct: "Nessun abbonamento attivo per questo prodotto.",
    emptyProductHint: "Scegli un piano per iniziare a usare questo prodotto.",
    includedPlaceholder: "Incluso nel piano — in arrivo.",
    usagePlaceholder: "Consumo — in arrivo.",
    overview: {
      subscriptionTitle: "Abbonamento",
      creditsTitle: "Crediti",
      addonsTitle: "Componenti aggiuntivi",
      activeBadge: "Attivo",
      inactiveBadge: "Inattivo",
      nextBillingDate: "Prossima data di fatturazione",
      billingCycle: "Ciclo di fatturazione",
      billingCycleYearly: "Annuale",
      billingCycleMonthly: "Mensile",
      perYear: "/ anno",
      perMonth: "/ mese",
      creditSingular: "credito",
      creditPlural: "crediti",
      manageCredits: "Gestisci crediti",
      changeSubscription: "Modifica abbonamento",
      choosePlan: "Scegli piano",
      buyAddons: "Acquista add-on",
      cancelSubscription: "Annulla abbonamento",
      planLabel: "Piano",
      statusLabel: "Stato",
      priceLabel: "Prezzo",
      createdLabel: "Creato",
      includedCountries: "Paesi inclusi",
      includedUsers: "Utenti inclusi",
      vatReturns: "Dichiarazioni IVA",
      statesIncluded: "Stati inclusi",
      registrationsIncluded: "Registrazioni",
      autoFiling: "Invio automatico",
      includedFeaturesTitle: "Funzionalità incluse",
      subscriptionDetailsTitle: "Dettagli abbonamento",
      summaryTitle: "Riepilogo fatturazione",
      planCost: "Costo piano",
      addonsTotal: "Totale componenti",
      total: "Totale",
    },
  },
  tabs: {
    proforma: "Fattura proforma",
    taxInvoice: "Fattura fiscale",
    creditNote: "Nota di credito",
    payments: "Pagamenti",
    creditsSummary: "Riepilogo crediti",
  },
  proforma: {
    addonsLabel: "Add-ons:",
    viewPayment: "Visualizza",
  },
  filters: {
    searchPlaceholder: "Cerca",
    proformaSearchPlaceholder: "Cerca per numero fattura o nome",
    dateRangeLabel: "Intervallo di date",
    dateFrom: "Da",
    dateTo: "A",
    sortByStatus: "Filtra per stato",
    sortByStatusPrefix: "Ordina per stato:",
    statusAll: "Tutti",
    showAll: "Mostra tutto",
    appsPrefix: "App:",
    proformaStatusNew: "Nuovo",
    proformaStatusProcessed: "Elaborato",
    proformaStatusVoided: "Annullato",
    proformaStatusRefund: "Rimborso",
    proformaStatusBalanceRefund: "Rimborso sul saldo",
    proformaAppLTax: "L'Tax",
    proformaAppLEpr: "L'EPR",
    proformaAppLInvoice: "L'Invoice",
    proformaAppLAuthorize: "L'Authorize",
    advancedFiltersTrigger: "Filtri avanzati",
    advancedFiltersTitle: "Filtri avanzati",
    advanced: {
      subscriptionType: "Tipo di abbonamento",
      subscriptionPlaceholder: "Seleziona abbonamento",
      addons: "Componenti aggiuntivi",
      addonsPlaceholder: "Seleziona componenti aggiuntivi",
      amount: "Importo",
      amountPlaceholder: "Inserisci importo",
      optionNone: "\u2014",
      addonMockReports: "Reporting",
      addonMockCompliance: "Conformità",
    },
  },
  filterTabs: {
    moreOptions: "Altre opzioni",
  },
  statuses: {
    PAID: "Pagato",
    PENDING: "In sospeso",
    OPEN: "Aperto",
    COMPLETED: "Completato",
    CLOSED: "Chiuso",
    FAILED: "Non riuscito",
    CANCELLED: "Annullato",
    paid: "Pagato",
    due: "Scaduto",
    credited: "Accreditato",
  },
  statusFilter: {
    ALL: "Tutti",
    PAID: "Pagato",
    PENDING: "In sospeso",
    OPEN: "Aperto",
    COMPLETED: "Completato",
    CLOSED: "Chiuso",
  },
  table: {
    created: "Creato",
    invoiceName: "Nome fattura",
    creditNoteName: "Nome nota di credito",
    relatedInvoice: "Fattura correlata",
    number: "Numero",
    billingPeriod: "Periodo di fatturazione",
    status: "Stato",
    payment: "Pagamento",
    app: "App",
    amount: "Importo",
    actions: "Azioni",
  },
  billingTableEmpty: {
    title: "Nessun risultato",
    proformaTitle: "Nessun elemento trovato",
    proformaEmptyDescription: "Al momento non hai fatture proforma.",
    emptyNoSearch: "Al momento non hai {{entity}}.",
    searchNoMatch: "La ricerca «{{query}}» non ha prodotto risultati.",
    clearSearch: "Cancella ricerca",
    entities: {
      _default: "record per questa scheda",
      PROFORMA: "fatture proforma",
      TAX: "fatture fiscali",
      CREDIT_NOTE: "note di credito",
      PAYMENTS: "pagamenti",
      CREDITS_SUMMARY: "voci nel riepilogo crediti",
    },
  },
  loading: "Caricamento cronologia fatturazione…",
  error: "Impossibile caricare la cronologia fatturazione. Riprovare.",
  retry: "Riprova",
  billingRowActions: {
    viewDetails: "Vedi dettagli",
    view: "Visualizza",
    pay: "Paga",
    edit: "Modifica",
    void: "Annulla",
    restore: "Ripristina",
    download: "Scarica",
    delete: "Elimina",
  },
  rowActions: {
    download: "Scarica",
    view: "Vedi dettagli",
    copyNumber: "Copia numero fattura",
  },
  payments: {
    table: {
      type: "Tipo",
      paymentMethod: "Metodo di pagamento",
    },
  },
  creditsSummary: {
    cards: {
      salesTaxAvailable: "Crediti Sales Tax disponibili",
      salesListAvailable: "Crediti Sales list disponibili",
    },
    filters: {
      sortByTypePrefix: "Ordina per tipo:",
      sortAll: "Tutti",
      sortSalesTax: "Sales Tax",
      sortSalesList: "Sales List",
    },
    table: {
      description: "Descrizione",
      id: "ID",
      creditType: "Tipo di credito",
      creditsLeft: "Crediti rimanenti",
      amount: "Importo",
    },
  },
  taxInvoiceDetails: {
    status: "Stato",
    invoiceDate: "Data fattura",
    invoiceNumber: "Numero fattura",
    vatNumber: "Partita IVA",
    sectionTitle: "Dettagli fattura",
    colItem: "Voce",
    colQty: "Qtà",
    colPrice: "Prezzo",
    total: "Totale",
    downloadPdf: "Scarica PDF",
  },
  creditNoteDetails: {
    status: "Stato",
    createdDate: "Creato",
    number: "Numero",
    relatedInvoice: "Fattura correlata",
    sectionTitle: "Dettagli nota di credito",
    colItem: "Voce",
    colQty: "Qtà",
    colPrice: "Prezzo",
    total: "Totale",
    downloadPdf: "Scarica PDF",
  },
  proformaInvoiceDetails: {
    title: "Fattura proforma",
    titleWithNumber: "Fattura proforma {{number}}",
    app: "App",
    addonsHeading: "Componenti aggiuntivi",
    noInvoiceDetails: "Nessun dettaglio fattura",
  },
  proformaDeleteModal: {
    title: "Elimina fattura proforma",
    description:
      "Questa fattura proforma verrà eliminata in modo permanente. Questa azione non può essere annullata.",
    descriptionWithNumber:
      "La fattura proforma {{number}} verrà eliminata in modo permanente. Questa azione non può essere annullata.",
    cancel: "Annulla",
    delete: "Elimina",
  },
  proformaVoidModal: {
    title: "Annullare la fattura proforma?",
    description:
      "Questa azione contrassegnerà la fattura proforma come annullata. Potrai ripristinarla in seguito se necessario.",
    descriptionWithNumber:
      "La fattura proforma {{number}} sarà contrassegnata come annullata. Potrai ripristinarla in seguito se necessario.",
    cancel: "Annulla",
    void: "Annulla fattura",
    success: "Fattura proforma annullata correttamente.",
    errorGeneric: "Impossibile annullare questa fattura. Riprova.",
  },
  proformaRestoreModal: {
    title: "Ripristinare la fattura proforma?",
    description:
      "Questa azione ripristinerà la fattura proforma e imposterà di nuovo lo stato su Nuovo.",
    cancel: "Annulla",
    restore: "Ripristina fattura",
    success: "Fattura proforma ripristinata correttamente.",
    errorGeneric: "Impossibile ripristinare questa fattura. Riprova.",
  },
  proformaPayModal: {
    title: "Paga fattura proforma",
    description:
      "Vuoi pagare la fattura proforma {{number}} del {{date}} per {{amount}}?",
    numberFallback: "\u2014",
    cancel: "Annulla",
    pay: "Paga",
    shopifyPay: "Acquista ora con Shopify Pay",
  },
  proformaInvoiceEdit: {
    drawerTitle: "Modifica fattura proforma",
    cancel: "Annulla",
    save: "Salva",
    pdfLabel: "Fattura PDF",
    removeFile: "Rimuovi",
    errorTitle: "Salvataggio non riuscito",
    errorGeneric: "Impossibile salvare le modifiche.",
    errorNumberRequired: "Inserisci il numero di fattura.",
    errorSumRequired: "Inserisci l’importo.",
    errorSumInvalid: "Inserisci un importo valido.",
    errorUploadAfterSave: "La fattura è stata salvata ma il caricamento del PDF non è riuscito.",
    createdDateLabel: "Data di creazione",
    createdDatePlaceholder: "Seleziona data di creazione",
    paymentDateLabel: "Data di pagamento",
    paymentDatePlaceholder: "Seleziona data di pagamento",
  },
  mainTabSoon: "Disponibile a breve",
};

export default productSettings;
